import { useReducer, useEffect } from "react";
import stepChartReducer, { combinedInitialState } from "./reducer";
import { fetchChargerStatus } from "./api";
import ACTIONS from "./actions";

async function getChargerStatus(dispatch, chargerId, timeRange) {
  const [startTime, endTime] = timeRange;
  dispatch({ type: ACTIONS.FETCH_CHARGER_STATUS_INIT });
  try {
    const chargerStatusData = await fetchChargerStatus(chargerId, startTime?.toISOString(), endTime?.toISOString());
    if (chargerStatusData) {
      const data = chargerStatusData.map(item => ({
        ...item,
        ts: new Date(item.ts).getTime(),
      }));
      data.sort((a, b) => a.ts - b.ts);
      dispatch({ type: ACTIONS.FETCH_CHARGER_STATUS_SUCCESS, payload: data });
    } else {
      dispatch({ type: ACTIONS.FETCH_CHARGER_STATUS_FAILURE });
    }
  } catch (error) {
    dispatch({ type: ACTIONS.FETCH_CHARGER_STATUS_FAILURE });
  }
}

function useStepChartReducer({ chargerId, timeRange }) {
  const [state, dispatch] = useReducer(stepChartReducer, combinedInitialState);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (chargerId && timeRange) {
        getChargerStatus(dispatch, chargerId, timeRange);
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [chargerId, timeRange]);

  // return only the status (step chart) slice to preserve previous hook API
  return {
    status: state.status,
    dispatch,
  };
}

export default useStepChartReducer;
